import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import qs from 'querystring';
import uri from 'url'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import isPlainObject from 'lodash.isplainobject';

var wrapWithClickProps = function wrapWithClickProps(defaultComponent) {
  var Click =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Click, _React$Component);

    function Click(props) {
      var _this;

      _classCallCheck(this, Click);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Click).call(this, props));
      _this.state = {
        header_pageViewId: null
      };
      return _this;
    }

    _createClass(Click, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // Only let clients that execute JS see pageviewid
        this.setState({
          header_pageViewId: this.getPageViewId()
        });
      }
    }, {
      key: "getPageViewId",
      value: function getPageViewId() {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        if (this.props.pageViewId) {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          return this.props.pageViewId;
        }

        if (typeof window !== 'undefined' && window.nwa != null) {
          return window.nwa.getGlobalProp('pageViewId');
        }

        return null;
      }
    }, {
      key: "constructURL",
      value: function constructURL() {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        var parsedUrl = uri.parse(this.props.href);
        var existingProps = qs.parse(parsedUrl.query);

        var props = _objectSpread({}, existingProps, this.props.eventProps, {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          header_pageViewId: this.state.header_pageViewId
        });

        var keys = Object.keys(props);

        if (keys.length) {
          // Support nested props to 1 level deep
          keys.forEach(function (key) {
            if (isPlainObject(props[key])) {
              var subKeys = Object.keys(props[key]);
              subKeys.forEach(function (subKey) {
                props["".concat(key, "_").concat(subKey)] = props[key][subKey];
              });
              delete props[key];
            }
          }); // Support legacy `pos` prop as a duplicate of productPosition

          if (props.pos == null && props.clickHeader_productPosition) {
            props.pos = props.clickHeader_productPosition;
          }

          delete parsedUrl.search; // Delete `search` so `format` uses `query` instead

          parsedUrl.query = props;
          return uri.format(parsedUrl);
        } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


        return this.props.href;
      }
    }, {
      key: "render",
      value: function render() {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        var Component = this.props.component || defaultComponent;

        var props = _objectSpread({}, this.props, {
          href: this.constructURL(),
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          target: this.props.newWindow ? '_blank' : null
        });

        delete props.eventProps;
        delete props.newWindow;
        delete props.pageViewId;
        delete props.component;
        delete props.dispatch;
        return React.createElement(Component, props);
      }
    }]);

    return Click;
  }(React.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  Click.defaultProps = {
    newWindow: true
  }; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

  Click.propTypes = {
    href: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
    eventProps: PropTypes.object,
    newWindow: PropTypes.bool,
    // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
    pageViewId: PropTypes.string,

    /**
     * Use a custom component instead of the default 'a' html component.
     */
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
    component: PropTypes.any
  };
  return Click;
};

export default wrapWithClickProps('a');
export { wrapWithClickProps };